/**
 * Shared layout constants for `PriceRangeBar` and `PriceRangeBarSkeleton`.
 * Keeps the two components pixel-aligned — when one updates a row height or
 * a corner radius, the other follows automatically and the skeleton → live
 * swap stays layout-shift-free.
 */

/** Height of the colored segment track. */
export const BAR_HEIGHT = 8

/** Gap between the three segments inside the bar track. */
export const SEGMENT_GAP_PX = 4

/**
 * Vertical space reserved for the tooltip row (bubble + tail). Set as a
 * fixed pixel value rather than a spacing token because the tail eats into
 * the row's bottom edge — the live component compensates with a negative
 * `margin-top: -1px` on the tail and a `calc(spacing.s400 - 1px)`
 * margin-bottom on the row itself.
 */
export const TOOLTIP_ROW_HEIGHT = 30

/**
 * Per-corner radii for each segment. Outer ends are pill-rounded (5px =
 * half the bar height); inner ends use a small 2px curve. Atlas radius
 * tokens (CSS variables) were not resolving correctly when applied to the
 * individual `border-*-radius` properties on these segments, so explicit
 * pixel values are used here.
 */
export const SEGMENT_RADIUS = {
  low: {tl: '5px', tr: '2px', br: '2px', bl: '5px'},
  fair: {tl: '2px', tr: '2px', br: '2px', bl: '2px'},
  high: {tl: '2px', tr: '5px', br: '5px', bl: '2px'}
} as const
